import React from "react"
import PropTypes from "prop-types"
import { appConstants } from "../../../constants/app_constants";
import Image from '../../../assets/images/signup.png';

const ListItemsForDescription = [
  'Streamline payroll management with robust facial recognition',
  'Elevate access security through AI-Driven solutions',
  'Analyze emotions for deeper insights and engagement',
  'Fortify data and system access with facial authentication'
]

const BackgroundAuthentication = props => {
  return (

    <div className={`${props.isFromNewPwd ? "main-page-new-password-description" : "main-page-description"}`}>
      <div className="container custom-container">
        <div className="bg-container">
          <div className="content">
            <div className="title">
              {`${appConstants.cName} API: Where Faces`} <br />
              Unlock Possibilities
            </div>
            <ul className="list-container">
              {ListItemsForDescription.map((ele, i) => (
                <li key={i} className="list-item">{ele}</li>
              ))}
            </ul>
            {props.Image && (
              <img src={Image} alt="image" className="signupImg" />
            )}


          </div>
          {props.form}
        </div>

      </div>
    </div>

  )
}

export default BackgroundAuthentication

BackgroundAuthentication.propTypes = {
  form: PropTypes.any,
}
